module.exports = __webpack_public_path__ + "static/media/70.f5dcfed1.png";